export default __webpack_public_path__ + "static/media/Chord1.d2619408.mp3";